import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	width: 2400,
	height: 2400,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10M9 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M5.99 21.142C6.404 18.247 8.966 16 12 16s5.596 2.247 6.01 5.142a1 1 0 0 0 1.98-.284C19.434 16.968 16.02 14 12 14s-7.433 2.968-7.99 6.858a1 1 0 0 0 1.98.284"
	})]
});
export default SvgUser;
